var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header_wrap" }, [
        _c(
          "div",
          { staticStyle: { width: "60%" } },
          [
            _c(
              "el-steps",
              {
                staticStyle: { width: "100%" },
                attrs: { "align-center": "", active: 3 }
              },
              [
                _c("el-step", {
                  attrs: {
                    title:
                      _vm.transportTypeCode == "KY"
                        ? _vm.$t("i18n_Air_Freight_Information")
                        : _vm.transportTypeCode == "HY"
                        ? _vm.$t("i18n_ocean_freight_information")
                        : _vm.transportTypeCode == "LY"
                        ? _vm.$t("i18n_land_transportation_information")
                        : ""
                  }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_Value_added_service") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_shipping_information") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_confirm_order") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_order_completed") }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "center_wrap" }, [
        _c("div", { staticClass: "wrap_l" }, [
          _c("div", {
            staticStyle: { display: "-webkit-flex", "align-items": "center" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "-webkit-flex",
                  "align-items": "center",
                  "margin-bottom": "20px"
                }
              },
              [
                _c("img", {
                  attrs: { src: require("../../assets/weituo.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tittype" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_Order_Information")))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "header_text" }, [
              _c(
                "div",
                {
                  staticClass: "count_center",
                  staticStyle: { "margin-right": "50px" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "cangkutit",
                      staticStyle: { color: "red", "font-weight": "bold" }
                    },
                    [_vm._v(_vm._s(_vm.fromFABck.namec))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "ckttext",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_Original_Port")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cangkutit",
                  staticStyle: { "margin-right": "50px" }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.transportTypeCode == "KY",
                        expression: "transportTypeCode == 'KY'"
                      }
                    ],
                    staticStyle: { width: "60px" },
                    attrs: {
                      src: require("../../../static/images/KY.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.transportTypeCode == "HY",
                        expression: "transportTypeCode == 'HY'"
                      }
                    ],
                    staticStyle: { width: "60px" },
                    attrs: {
                      src: require("../../../static/images/HY.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.transportTypeCode == "LY",
                        expression: "transportTypeCode == 'LY'"
                      }
                    ],
                    staticStyle: { width: "60px" },
                    attrs: {
                      src: require("../../../static/images/LY.png"),
                      alt: ""
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "count_center" }, [
                _c(
                  "span",
                  {
                    staticClass: "cangkutit",
                    staticStyle: { color: "red", "font-weight": "bold" }
                  },
                  [
                    _vm._v(_vm._s(_vm.toFABck.country) + "\n              "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "15px",
                          "font-size": "16px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.toFABck.namec))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ckttext",
                    staticStyle: { "margin-top": "10px" }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_Destination")))]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "good_count" },
              _vm._l(_vm.BoxShowLable, function(item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "shouMargin" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("i18n_Product_Type")) +
                                ":" +
                                _vm._s(item.typeName) +
                                "\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "shouMargin" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("i18n_Total_weight")) +
                                "：" +
                                _vm._s(item.weight) +
                                "\n                  "
                            ),
                            _c("span", { staticClass: "ckttext" }, [
                              _vm._v("KG")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "shouMargin" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("i18n_Total_pieces")) +
                                "：\n                  " +
                                _vm._s(item.goodsDTOnum) +
                                "\n                  "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "ckttext",
                                staticStyle: { "margin-left": "4px" }
                              },
                              [_vm._v(_vm._s(_vm.$t("i18n_Pieces")))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "shouMargin" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("i18n_total_volume1")) +
                                "：" +
                                _vm._s(item.cbm)
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "ckttext",
                                staticStyle: { "margin-left": "4px" }
                              },
                              [_vm._v("CBM")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "shouMargin" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("i18n_Total_boxes")) +
                                "：" +
                                _vm._s(item.boxNum ? item.boxNum : 1)
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "ckttext",
                                staticStyle: { "margin-left": "4px" }
                              },
                              [_vm._v(_vm._s(_vm.$t("i18n_Boxes")))]
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.BoxShowLable.length > 1,
                            expression: "BoxShowLable.length > 1"
                          }
                        ]
                      },
                      [_c("el-divider")],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap_R", class: _vm.auto_fixed ? "auto_fixed" : "" },
          [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("i18n_cost_calculation")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "OrderDetails" }, [
              _c(
                "div",
                {
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_shipping_cost")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.FBATransmoney.goodsTypeFeeDTOS, function(
                    item,
                    index
                  ) {
                    return _c("p", { key: index, staticClass: "coutText" }, [
                      _c("span", { staticClass: "littit" }, [
                        _vm._v(_vm._s(item.goodsTypeName))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fontString" }, [
                        _vm._v(_vm._s(item.currency) + _vm._s(item.amount))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("(" + _vm._s(item.calDesc) + ")")
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.FBATransmoney.currency) +
                          _vm._s(_vm.FBATransmoney.amount)
                      )
                    ])
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.THFdata.checked,
                      expression: "THFdata.checked"
                    }
                  ],
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_pickup_fee")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_pickup_at_original_port")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.THFdata.currency) +
                          _vm._s(_vm.THFdata.amount)
                      )
                    ]),
                    _vm._v(" "),
                    _vm.THFdata.maxKilometer > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "littit",
                            staticStyle: { float: "left", width: "100%" }
                          },
                          [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.THFdata.minKilometer) +
                                "--" +
                                _vm._s(_vm.THFdata.maxKilometer) +
                                ")" +
                                _vm._s(_vm.$t("i18n_Kilometers"))
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.formData.totalExpense
                ? _c(
                    "div",
                    { staticClass: "Item_Right" },
                    [
                      _c("p", { staticClass: "tit" }, [
                        _vm._v(_vm._s(_vm.$t("i18n_Value_Added_Service_Fee")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.formData.feeItemDTOS, function(item, index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.checked,
                                expression: "item.checked"
                              }
                            ],
                            key: index,
                            staticClass:
                              "coutText animate__animated animate__bounceInRight"
                          },
                          [
                            item.feeCode === "CLEF"
                              ? _c("span", { staticClass: "littit" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "i18n_customs_declaration_with_tax_refund"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", { staticClass: "littit" }, [
                                  _vm._v(_vm._s(item.feeName))
                                ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "fontString" }, [
                              _vm._v(
                                _vm._s(item.currency) +
                                  "  " +
                                  _vm._s(item.amount) +
                                  "  (" +
                                  _vm._s(item.calDesc) +
                                  ")"
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "coutText animate__animated animate__bounceInRight",
                          staticStyle: { color: "#ff3030" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "littit",
                              staticStyle: { color: "#ff3030" }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_subtotal")) + ":")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "fontString" }, [
                            _vm._v(_vm._s(_vm.formData.totalExpense))
                          ])
                        ]
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "Item_Right" }, [
                _c(
                  "p",
                  {
                    staticClass: "coutText",
                    staticStyle: {
                      "justify-content": "flex-start",
                      gap: "10px"
                    }
                  },
                  [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_total_cost")))
                    ]),
                    _vm._v(" "),
                    _vm._l(this.newArray, function(item, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.amount > 0,
                              expression: "item.amount > 0"
                            }
                          ],
                          key: index
                        },
                        [
                          _c("span", [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.currency != "",
                                    expression: "item.currency != ''"
                                  }
                                ],
                                staticClass: "fontString"
                              },
                              [_vm._v(_vm._s(item.currency))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.amount > 0,
                                    expression: "item.amount > 0"
                                  }
                                ],
                                staticClass: "fontString",
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px"
                                }
                              },
                              [_vm._v(_vm._s(item.amount))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    index == _vm.newArray.length - 1
                                      ? false
                                      : true,
                                  expression:
                                    "index == newArray.length - 1 ? false : true"
                                }
                              ]
                            },
                            [_vm._v("+")]
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_Covert_to_CNY")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v("CNY " + _vm._s(_vm.calculatePrice))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "goodsValueCount" }, [
                _c("div", { staticClass: "goodsValue_name" }, [
                  _vm._v("货值统计")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "goodsValue_fat" }, [
                  _c("div", { staticClass: "goodsValue_box" }, [
                    _vm._v("箱数:" + _vm._s(_vm.getBoxNum) + " 箱")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "goodsValue_value" }, [
                    _vm._v("货值:" + _vm._s(_vm.getGoodsValue) + " USD")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "margin-top": "30px",
                  float: "left"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        on: {
                          click: function($event) {
                            return _vm.pathToback()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Previousstep")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-top": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          width: "100%",
                          background: "#5ab53c",
                          color: "#ffffff"
                        },
                        on: {
                          click: function($event) {
                            return _vm.Qdshowcount()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_confirm_order")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-top": "10px",
                      "text-align": "center"
                    }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.checkedQd,
                          callback: function($$v) {
                            _vm.checkedQd = $$v
                          },
                          expression: "checkedQd"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("i18n_tick_term")) + "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "text-decoration": "underline" },
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.openPolicy()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "《" +
                            _vm._s(_vm.$t("i18n_Carriage_goods_agreement")) +
                            "》"
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("i18n_Are_your_confirm_order"),
            center: "",
            visible: _vm.dialogTableVisible,
            width: "520px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "showDalog" }, [
            _c("div", { staticClass: "header_text" }, [
              _c(
                "div",
                {
                  staticClass: "count_center",
                  staticStyle: { "margin-right": "50px" }
                },
                [
                  _c(
                    "span",
                    { staticClass: "cangkutit", staticStyle: { color: "red" } },
                    [_vm._v(_vm._s(_vm.fromFABck.namec))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "ckttext",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_receving_warehosue")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cangkutit",
                  staticStyle: { "margin-right": "50px" }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.transportTypeCode == "KY",
                        expression: "transportTypeCode == 'KY'"
                      }
                    ],
                    staticStyle: { width: "60px" },
                    attrs: {
                      src: require("../../../static/images/KY.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.transportTypeCode == "HY",
                        expression: "transportTypeCode == 'HY'"
                      }
                    ],
                    staticStyle: { width: "60px" },
                    attrs: {
                      src: require("../../../static/images/HY.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.transportTypeCode == "LY",
                        expression: "transportTypeCode == 'LY'"
                      }
                    ],
                    staticStyle: { width: "60px" },
                    attrs: {
                      src: require("../../../static/images/LY.png"),
                      alt: ""
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "count_center" }, [
                _c(
                  "span",
                  { staticClass: "cangkutit", staticStyle: { color: "red" } },
                  [_vm._v(_vm._s(_vm.toFABck.namec) + "\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ckttext",
                    staticStyle: { "margin-top": "10px" }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_destination")))]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "goodlist",
                staticStyle: {
                  "margin-top": "40px",
                  width: "100%",
                  float: "left",
                  padding: "0px 40px",
                  "box-sizing": "border-box",
                  "margin-bottom": "30px"
                }
              },
              [
                _c("p", { staticStyle: {} }, [
                  _vm._v(_vm._s(_vm.$t("i18n_estimated_cost")))
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { padding: "5px" } }, [
                  _c(
                    "p",
                    {
                      staticStyle: { "font-weight": "bold", color: "#333333" }
                    },
                    [
                      _vm._v(
                        "\n            CNY " +
                          _vm._s(_vm.calculatePrice) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "Qdbtn LR_center",
                staticStyle: { "margin-top": "30px" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "btnstyle",
                    staticStyle: {
                      height: "35px",
                      background: "#ffffff",
                      border: "2px solid #dcdcdc",
                      "border-radius": "35px"
                    },
                    on: {
                      click: function($event) {
                        _vm.dialogTableVisible = false
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("i18n_cancel")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btnstyle",
                    staticStyle: {
                      border: "1px solid #5ab53c",
                      "font-size": "30rpx",
                      background: "#ff3939",
                      "border-color": "#ff3939",
                      color: "#ffffff"
                    },
                    on: {
                      click: function($event) {
                        return _vm.pathToNext()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("i18n_confirm_order")) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "服务条款",
            center: "",
            visible: _vm.policyDialog,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.policyDialog = $event
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c(
              "p",
              { staticStyle: { "font-size": "16px", "line-height": "20px" } },
              [_c("b", [_vm._v("货物承运电子协议")])]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { "font-size": "16px", "line-height": "20px" } },
              [_c("b", [_vm._v("Carriage of goods agreement")])]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "line-height": "18px" } },
            [
              _c("p", [_c("b", [_vm._v("更新发布时间：2024年8月7日")])]),
              _vm._v(" "),
              _c("p", { staticStyle: { "margin-bottom": "25px" } }, [
                _c("b", [_vm._v("Update: August 7, 2024")])
              ]),
              _vm._v(" "),
              _c("serviceAgreement", { attrs: { showTitle: false } })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e1aa649", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e1aa649","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBAorder/Fbaqdbill.vue
// module id = null
// module chunks = 